module.exports = __webpack_public_path__ + "img/83ne.cc73402b.svg";